import { FunctionComponent } from 'react';
import TopMenu from '../shared/top-menu/top-menu';
import Footer from '../shared/footer/footer';
import './education.scss';
import EducationTopBanner from './education-top-banner';

import EducationUnit from './education-unit';
import { allVideosDE, allVideosEN } from './all-videos';
import DIV from '../shared/html-tags/div';
import { Helmet } from 'react-helmet-async';

export type Props = {};

//fetchPlaylistVideos('PL9fun6Swcz_DrLzHtapioiFOLsT4GUC0F');

const Education: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO Education</title>
        <meta
          name="description"
          content="Entdecke unsere umfassenden Video-Tutorials, die dir helfen, das volle Potenzial von PS IMAGO PRO auszuschöpfen."
        />
        <meta
          name="keywords"
          content="PS IMAGO PRO, Education, Tutorials, Predictive Solutions, Analyse, Reporting"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/education" />
      </Helmet>

      <div className="page education">
        <TopMenu selected="education"></TopMenu>
        <EducationTopBanner />

        <div className="page-content bg-1">
          <div className="inner-content">
            <DIV language="de" className="education-units">
              {allVideosDE.map((video, i) => (
                <EducationUnit
                  key={i}
                  numVideo={i + 1}
                  name={video.title}
                  description={video.description}
                  duration={video.lengthInSeconds}
                  videolink={video.link}
                  preview={''}
                />
              ))}
            </DIV>
            <DIV language="en" className="education-units">
              {allVideosEN.map((video, i) => (
                <EducationUnit
                  key={i}
                  numVideo={i + 1}
                  name={video.title}
                  description={video.description}
                  duration={video.lengthInSeconds}
                  videolink={video.link}
                  preview={''}
                />
              ))}
            </DIV>
          </div>
        </div>

        <Footer></Footer>
      </div>
    </>
  );
};

export default Education;
